import script from "./userMoneyForm.vue?vue&type=script&setup=true&lang=js"
export * from "./userMoneyForm.vue?vue&type=script&setup=true&lang=js"

import "./userMoneyForm.vue?vue&type=style&index=0&id=24f2702c&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24f2702c"]])

export default __exports__